import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubscription = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.25 5.25H2.25C1.85217 5.25 1.47064 5.40804 1.18934 5.68934C0.908035 5.97064 0.75 6.35217 0.75 6.75V18.75C0.75 19.1478 0.908035 19.5294 1.18934 19.8107C1.47064 20.092 1.85217 20.25 2.25 20.25H14.25",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.75 9.75H13.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 14.25H9",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.25 5.8125H18.975C18.3186 5.8125 17.6891 6.07326 17.225 6.5374C16.7608 7.00153 16.5 7.63109 16.5 8.2875C16.5 11.9995 23.25 11.9995 23.25 15.7125C23.2497 16.3689 22.9889 16.9982 22.5248 17.4623C22.0607 17.9263 21.4314 18.1872 20.775 18.1875H16.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.875 5.8125V3.5625",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.875 18.1875V20.4375",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSubscription;
